export function drawGridLines(data, ctx, canvas, theme) {
  let gridLine = new gridLines();
  gridLine.draw(data, ctx, canvas, theme);
}

class gridLines {

  draw(data, ctx, canvas, theme) {

    
    // console.log("theme : " + theme);
    if (theme === 'dark') {
      ctx.strokeStyle = 'grey';
      ctx.lineWidth = 1;
    } else {
      ctx.strokeStyle = 'grey';
      ctx.lineWidth = 1;
    }
    const h_size = canvas.width / data.size;
    for (let i = h_size; i < canvas.height; i = i + h_size) {
      //Horizontal Lines
      ctx.beginPath();
      ctx.moveTo(i, 0);
      ctx.lineTo(i, canvas.height);
      ctx.stroke();
    }

    const w_size = canvas.height / data.size;
    for (let i = w_size; i < canvas.width; i = i + w_size) {

      ctx.beginPath();
      ctx.moveTo(0, i);
      ctx.lineTo(canvas.width, i);
      ctx.stroke();
      // ctx.shadowBlur = 1;
      // ctx.shadowColor = '#fff';
    }

  }
}
